import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'

import { agentApi } from '@/services/AgentService';
Vue.prototype.$agent = agentApi
import { userApi } from '@/services/UserService';
Vue.prototype.$user = userApi
import { apptApi } from '@/services/AppointmentService';
Vue.prototype.$appoint = apptApi
import { documentApi } from '@/services/DocumentService';
Vue.prototype.$document = documentApi
import { templateApi } from '@/services/TemplateService';
Vue.prototype.$template = templateApi
import { reportApi } from '@/services/ReportService';
Vue.prototype.$reports = reportApi


// Use the Auth services to secure the site
import AuthService from '@/services/AuthServices';
Vue.prototype.$auth = new AuthService()

// Alerts
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

// Store
import Vuex from 'vuex'
Vue.use(Vuex)

// Interpolation Filters
import moment from 'moment'
Vue.filter('shortDate', function(value) {
   if (value) {
     return moment(String(value), moment.ISO_8601).format('MM/DD/YYYY')
   }
})
Vue.filter('phone', function (phone) {
   if (phone) {
      return phone.replace(/[^0-9]/g, '')
         .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
   }
});
Vue.filter('currency', function (value) {
   if (value || value == '0') {
      let val = (value/1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
   }
});
Vue.filter('twoplaces', function (value) {
   if (value || value == '0') {
      let val = (value/1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
   }
});
Vue.filter('coNameFix', function (value) {
   if (!value || value.length < 27) return value
   let nuVal = value
   if (value.substr(24,1)!=" " && value.substr(26,1)!=" " && value.substr(25,1)==" ") {
      nuVal = value.substr(0,25) + value.substr(26)
   }
   return nuVal
});


// Progress bar
import vueTopprogress from 'vue-top-progress'
vueTopprogress.speed = 200;
Vue.use(vueTopprogress)

// Tooltips: https://stackoverflow.com/questions/37078423/how-can-add-bootstrap-tooltip-inside-vue-js/42461598
import $ from 'jquery'
const bsTooltip = (el, binding) => {
   const t = []
   if (binding.modifiers.focus) t.push('focus')
   if (binding.modifiers.hover) t.push('hover')
   if (binding.modifiers.click) t.push('click')
   if (!t.length) t.push('hover')
 
   $(el).tooltip({
     title: binding.value,
     placement: binding.arg || 'top',
     trigger: t.join(' '),
     html: !!binding.modifiers.html,
   })
 }
 Vue.directive('tooltip', {
   bind: bsTooltip,
   update: bsTooltip,
   unbind (el) {
     $(el).tooltip('dispose')
   }
 })

 Vue.config.ignoredElements = [/^section-bar/];

import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

